function minimumFractionDigits(data: number) {
  if (!Number.isInteger(data)) {
    return 2;
  }
  return 0;
}
export default minimumFractionDigits;
